const getLZoomData = (scene: any) => {
  let minX = 1000000;
  let minZ = 1000000;
  let maxX = -10000000;
  let maxZ = -10000000;

  for (let i = scene.children.length - 1; i >= 0; i--) {
    if (
      scene.children[i].name.includes('Connection') ||
      scene.children[i].name.includes('Origo')
    ) {
      if (scene.children[i].position.x < minX) {
        minX = scene.children[i].position.x;
      }

      if (scene.children[i].position.z < minZ) {
        minZ = scene.children[i].position.z;
      }

      if (scene.children[i].position.x > maxX) {
        maxX = scene.children[i].position.x;
      }

      if (scene.children[i].position.z > maxZ) {
        maxZ = scene.children[i].position.z;
      }
    }
  }

  const vec1 = new THREE.Vector2(minX, minZ);
  const vec2 = new THREE.Vector2(maxX, maxZ);

  let returnDist = vec1.distanceTo(vec2);

  if (returnDist < 5000) {
    returnDist = 5000;
  }

  return {
    LongetDistance: returnDist,
    ZoomCenter: new THREE.Vector3((minX + maxX) / 2, 0, (minZ + maxZ) / 2),
  };
};

const setEnviroment = ({
  camera,
  controls,
  scene,
  status,
}: {
  camera: any;
  controls: any;
  scene: any;
  status: any;
}): any => {
  if (status === '2d') {
    // get current camera

    controls.saveState();

    // Remove meshes to show only lines
    for (let i = scene.children.length - 1; i >= 0; i--) {
      if (window.all2dObjects.includes(scene.children[i].name)) {
        if (scene.children[i].type !== 'SpotLight') {
          scene.children[i].visible = true;
        }
        continue;
      }

      scene.children[i].visible = false;
    }

    const zoomData = getLZoomData(scene);
    // set camera from y axis
    camera.position.x = zoomData.ZoomCenter.x;
    camera.position.y = zoomData.LongetDistance;
    camera.position.z = zoomData.ZoomCenter.z;

    // remove rotation
    controls.enableRotate = false;
    controls.target = zoomData.ZoomCenter;

    window.SetToggleStatus('2d');
    return;
  }

  // set current camera active
  controls.reset();
  controls.enableRotate = true;

  // Fill with meshes
  for (let i = scene.children.length - 1; i >= 0; i--) {
    if (window.all3dObjects.includes(scene.children[i].name)) {
      if (scene.children[i].type !== 'SpotLight') {
        scene.children[i].visible = true;
      }
      continue;
    }

    scene.children[i].visible = false;
  }

  window.GetAllWallLinesToAddWalls(true, false);

  window.SetToggleStatus('3d');
};

export default setEnviroment;
